import { render, staticRenderFns } from "./CavitationViz.vue?vue&type=template&id=243b874e&scoped=true"
import script from "./CavitationViz.vue?vue&type=script&lang=js"
export * from "./CavitationViz.vue?vue&type=script&lang=js"
import style0 from "./CavitationViz.vue?vue&type=style&index=0&id=243b874e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243b874e",
  null
  
)

export default component.exports